export const ACTIONS_TRUCK_MODEL = {
  INVALIDATE: 'TRUCK_MODELS_INVALIDATE',
  RECEIVE: 'TRUCK_MODELS_RECEIVE',
  DELETE: 'TRUCK_MODEL_DELETE',
  UPDATE: 'TRUCK_MODEL_UPDATE',
};

const truckModelConstants = {};

export default truckModelConstants;
